// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"G3-z","subtitle":"H3-z","wrapper":"I3-z","leftArrow":"J3-z","rightArrow":"K3-z"};